import { tracePathsFilter } from "datadog-loader/trace-paths-filter";

import { restrictedBeforeSend } from "drop-in-ui/components/datadog/resticted-before-send";
import { DD_APPID, DD_CLIENTTOKEN, TARGET } from "drop-in-ui/utils/configs";
import { VERSION } from "drop-in-ui/utils/version/version";

export const datadogConfig = {
  applicationId: DD_APPID,
  clientToken: DD_CLIENTTOKEN,
  env: TARGET,
  version: VERSION,
  service: "drop-in-ui",
  trackUserInteractions: true,
  allowedTracingUrls: [tracePathsFilter],
  beforeSend: restrictedBeforeSend,
};
